import { AxiosPromise } from 'axios';
import get from 'lodash/get';

import { http } from 'services';

import * as Types from './types';
import { getCaptchaToken } from 'helpers/captcha';

export const List = async ({ organizationId, params }: { organizationId: number; params: Types.IEntity.Params }): Promise<AxiosPromise<{ data: Types.IApi.Employee[]; }>> => {
  const page = get(params, 'page') ? Number(get(params, 'page')) : 0;
  const limit = get(params, 'limit') ? Number(get(params, 'limit')) : 10;
  const token = await getCaptchaToken()
  return http.request.get<{ data: Types.IApi.Employee[] }>(`/admin/employee/open_source`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    },
    params: {
      page: page - 1,
      size: limit,
      sort: `${params.sort.key},${params.sort.value ? 'asc' : 'desc'}`,
      level: 2,
      organization_id: organizationId
    } as Types.IApi.Params
  });
};
